var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Logout")]),_c('router-view',{staticClass:"page"}),_c('h3',[_vm._v("Please wait, logging out")]),_c('hr')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }